module.exports = __webpack_public_path__ + "static/media/img_24.171d1d48.png";